import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    item: {
      cursor: 'pointer',
      transform: 'translate3d(0, 0, 0)',
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
    isDragging: {
      border: '2px dashed rgba(0, 0, 0, 0.2)',
      borderRadius: 0,
      backgroundColor: 'transparent !important',
      cursor: 'grabbing',
      '& th, td': {
        opacity: 0,
      },
    },
  }),
);

export default useStyles;
